import React, { useEffect, useRef } from 'react'

const CustomCursor: React.FC = () => {
    const cursorRef = useRef<HTMLDivElement>(null)
    const cursorRingRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        let mouseX = 0
        let mouseY = 0
        let ringX = 0
        let ringY = 0

        const cursor = cursorRef.current
        const cursorRing = cursorRingRef.current

        if (!cursor || !cursorRing) return

        // Dot follows mouse instantly
        const handleMouseMove = (e: MouseEvent) => {
            mouseX = e.clientX
            mouseY = e.clientY
            cursor.style.left = mouseX + 'px'
            cursor.style.top = mouseY + 'px'
        }

        // Ring follows with smooth lag
        const animateRing = () => {
            ringX += (mouseX - ringX) * 0.12
            ringY += (mouseY - ringY) * 0.12
            cursorRing.style.left = ringX + 'px'
            cursorRing.style.top = ringY + 'px'
            requestAnimationFrame(animateRing)
        }

        document.addEventListener('mousemove', handleMouseMove)
        animateRing()

        return () => {
            document.removeEventListener('mousemove', handleMouseMove)
        }
    }, [])

    return (
        <>
            <div ref={cursorRef} id="cursor"></div>
            <div ref={cursorRingRef} id="cursor-ring"></div>
        </>
    )
}

export default CustomCursor
